import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
 
import {HttpClient} from "@angular/common/http";
 
 
@Component({
  selector: 'app-idea-modal',
  templateUrl: './idea-modal.component.html',
  styleUrls: ['./idea-modal.component.scss']
})
export class  IdeaModalComponent {

 
	loading:boolean = false
	done:boolean = false
	
	text:string = ''
	file:any = null
	
	
	constructor(protected ref: NbDialogRef<IdeaModalComponent>, private http: HttpClient){}


	 
 	
 	snd(){
 	

 		this.loading = true
 		 
 		const formData = new FormData()
 		
 		if(this.file){
 		
 			formData.append('file',this.file, this.file.name)
 			 
 		}
 		formData.append('text', this.text)
             //  formData.append('file',image, image.name)

             this.http.post(`/api/srv/idea`, formData).subscribe((resp)=>{
             		this.done = true
             		this.loading = false
             		
             
             }, ()=>{
             
              		this.loading = false
              		alert("Сталася помилка")
             });
 		
 	}


	
}
